import React from 'react';
import { safeNum, deltaDirection, deltaArrow } from '../../../utils/gpsFormUtils';

// Per-modality Δ cell (value + colored arrow). Shows PERCENTAGE POINTS delta. "nouveau" when missing in N-1.
const DeltaCell = ({ curPctOfRespondents, prevPctOfRespondents, isNew }) => {
  if (isNew) {
    return <span className="text-xs font-medium text-violet-600 dark:text-violet-400">nouveau</span>;
  }
  const pts = Math.round(
    (safeNum(curPctOfRespondents) - safeNum(prevPctOfRespondents)) * 100,
  );
  const dir = deltaDirection(pts, 0);
  const { glyph, className } = deltaArrow(dir);
  const sign = pts > 0 ? '+' : '';
  const unit = Math.abs(pts) <= 1 ? 'pt' : 'pts';
  return (
    <span className={`text-xs font-medium tabular-nums ${className}`}>
      {pts === 0 ? '=' : glyph} {pts === 0 ? `0 ${unit}` : `${sign}${pts} ${unit}`}
    </span>
  );
};

export default DeltaCell;
